<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex sm3 pr-1 v-if="!hideDateFilters">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromIssueDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="queryParams.fromIssueDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1 v-if="!hideDateFilters">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toIssueDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toIssueDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-text-field
              name="issueNo"
              label="Issue No"
              type="text"
              v-model="queryParams.issueNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="purchaseOrderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td @click="addPurchaseOrder(props.item)">
                <a>{{ props.item.issueNo }}</a>
              </td>
              <td>{{ props.item.purchaseType }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { commonService } from "../../services/common-service";
import { purchaseOrderService } from "../../services/purchase-order-service";

export default {
  name: "PurchaseOrderListDialog",
  props: {
    showDialog: Boolean,
    hideDateFilters: Boolean,
    params: Object,
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      warehouseId: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Purchase Type", value: "purchaseType" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    purchaseOrderList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams.fromIssueDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.queryParams.toIssueDate = commonService.formatDate(
            new Date(),
            "YYYY-MM-DD"
          );
          this.queryParams.issueNo = "";

          this.queryParams = {
            ...this.queryParams,
            ...this.params,
          };
          this.purchaseOrderList = [];
          this.getPurchaseOrderList();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.getPurchaseOrderList();
    },
    getPurchaseOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPurchaseOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    addPurchaseOrder(purchaseOrder) {
      this.dialogClose(purchaseOrder);
    },
    dialogClose(purchaseOrder) {
      this.$emit("close", purchaseOrder);
    },
  },
};
</script>